import React from 'react';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { QualificationSection } from './components/QualificationSection';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { OutcomesSection } from './components/OutcomesSection';
import { ProductContents } from './components/ProductContents';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#faf6f0]" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <QualificationSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <MechanismSection data-id="element-6" />
        <OutcomesSection data-id="element-7" />
        <ProductContents data-id="element-8" />
        <FaqSection data-id="element-9" />
        <FinalCta data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}